<template>
  <div>
    <main class="gate login">
      <div class="together">
        <img src="/rallyhood-white.svg" />
        Together with purpose!
      </div>
          <ChangePassword :resetToken="token" ></ChangePassword>
      <hr />
    </main>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { router } from "../common";
import {Capacitor} from "@capacitor/core";
import {userInfoPersistent} from "@/common/user-info";
import { App } from '@capacitor/app';
import { Preferences } from '@capacitor/preferences';
export default {
  data() {
    return {
      token: ""
    };
  },
  computed: {
  },


  created() {
    this.token = this.$route.query.prt || null
  },
  watch: {
    '$route.query.prt': {
      immediate: true,
      handler(val) {
        this.token = val || null
      }
    }
  },
  methods: {

  
  }
};
</script>

